import React from "react";
import { AccountSettingsProvider } from "./AccountSettingsUiContext";
import { AccountSettingsCard } from "./AccountSettingsCard";

export function AccountSettingsPage({ history }) {
  return (
    <AccountSettingsProvider>
      <AccountSettingsCard />
    </AccountSettingsProvider>
  );
}
